import { render, staticRenderFns } from "./indexEn.vue?vue&type=template&id=0b9355bc&scoped=true&"
import script from "./indexEn.vue?vue&type=script&lang=js&"
export * from "./indexEn.vue?vue&type=script&lang=js&"
import style0 from "./indexEn.vue?vue&type=style&index=0&id=0b9355bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9355bc",
  null
  
)

export default component.exports